import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../asset/img/logo.png'

const navItems = [
  { label: 'Dashboard', icon: 'ri-dashboard-line', path: '/dashboard' },
  { label: 'All courses', icon: 'ri-book-open-line', path: '/courses', active: true },
  { label: 'Resources', icon: 'ri-folder-line', path: '/resources' },
  { label: 'Friends', icon: 'ri-user-3-line', path: '/friends' },
  { label: 'Chats', icon: 'ri-message-3-line', path: '/chats' },
  { label: 'Settings', icon: 'ri-settings-3-line', path: '/settings' },
];

function Sidebar({activeNav,setActiveNav}) {
  const [joinModalOpen, setJoinModalOpen] = useState(false);
    const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  return (
    <aside className="left-sidebar">
      <div>
        <div className="logo-area">
          <img src={logo} alt='' />
          <span>MMao</span>
        </div>

        <a href='https://aonmao.me' target='_blank' className="join-btn" onClick={() => setJoinModalOpen(true)}>
          <i class="ri-add-large-fill"></i>
          Join a course
        </a>

        <nav className="nav-menu">
          {[
            { name: 'Home', icon: 'ri-home-3-fill' },
            { name: 'My courses', icon: 'ri-folder-video-fill' },
          { name: 'Documents', icon: 'ri-article-fill' },
            { name: 'Reviews', icon: 'ri-chat-ai-4-fill' },
          { name: 'Profile', icon: 'ri-user-3-fill' }
          ].map((item) => (
            <button
              key={item.name}
              className={`nav-item ${activeNav === item.name ? 'active' : ''}`}
              onClick={() => setActiveNav(item.name)}
            >
              <i class={item.icon}></i>
              <span>{item.name}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="upgrade-card">
        <h4>Contact admin</h4>
        <p>To attend online course, contact me.</p>
        <a target='_blank' href='https://aonmao.me' className="upgrade-card-btn" onClick={() => setUpgradeModalOpen(true)}>Contact</a>
      </div>
    </aside>
  );
}

export default Sidebar;